import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { AdhesionUnitWatcherInterface } from '@mbrtargeting/metatag-shared-types';
import { AdhesionUnitWatcher } from '@mbrtargeting/metatag-shared-modules';

@injectionTarget()
export class MetaTagAdhesionUnitWatcher extends AdhesionUnitWatcher implements AdhesionUnitWatcherInterface {
    @inject() configResolver!: ConfigResolver;
    constructor() {
        super();
        const { adhesionUnitQuery = '', adhesionUnitGap = '0' } = this.configResolver.getFeatureSettings();
        this.init({
            adhesionUnitQuery,
            adhesionUnitGap: parseInt(adhesionUnitGap)
        })
    }
}
